import { Partner } from './model'

export default {
  getPartner: state => {
    if (state.partner === null) {
      return null;
    }

    return new Partner(state.partner)
  }
}
